module.exports = __webpack_public_path__ + "static/media/amazon_pay.b0f59668.svg";